import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropZone", "preview", "previewTemplate", "label"]
  static values = { existingCount: Number }

  connect() {
    this.boundHighlight = this.highlight.bind(this)
    this.boundUnhighlight = this.unhighlight.bind(this)
    this.boundHandleDrop = this.handleDrop.bind(this)

    // Add event listeners for drag and drop
    const dropZone = this.dropZoneTarget
    ;['dragenter', 'dragover'].forEach(eventName => {
      dropZone.addEventListener(eventName, this.boundHighlight, false)
    })

    ;['dragleave', 'drop'].forEach(eventName => {
      dropZone.addEventListener(eventName, this.boundUnhighlight, false)
    })

    dropZone.addEventListener('drop', this.boundHandleDrop, false)
  }

  disconnect() {
    const dropZone = this.dropZoneTarget
    ;['dragenter', 'dragover'].forEach(eventName => {
      dropZone.removeEventListener(eventName, this.boundHighlight, false)
    })

    ;['dragleave', 'drop'].forEach(eventName => {
      dropZone.removeEventListener(eventName, this.boundUnhighlight, false)
    })

    dropZone.removeEventListener('drop', this.boundHandleDrop, false)
  }

  highlight(e) {
    e.preventDefault()
    e.stopPropagation()
    this.dropZoneTarget.classList.add('border-primary', 'bg-surface-alt')
  }

  unhighlight(e) {
    e.preventDefault()
    e.stopPropagation()
    this.dropZoneTarget.classList.remove('border-primary', 'bg-surface-alt')
  }

  handleDrop(e) {
    const dt = e.dataTransfer
    const files = dt.files

    if (files.length > 0) {
      if (this.validateLimit(files)) {
        this.inputTarget.files = files
        this.handleFiles(files)
      }
    }
  }

  handleFileSelect(e) {
    const files = e.target.files
    if (this.validateLimit(files)) {
      this.handleFiles(files)
    } else {
      e.target.value = "" // Clear the input
    }
  }

  validateLimit(files) {
    const max = 10
    const total = this.existingCountValue + files.length
    if (total > max) {
      alert(`You can only have a total of ${max} images. You currently have ${this.existingCountValue} and selected ${files.length} more.`)
      return false
    }
    return true
  }

  handleFiles(files) {
    // Clear existing NEW previews (keep persisted ones if possible, but simplest is to append or just show new ones)
    // The current UI separates persisted images (top) from upload area (bottom).
    // We might want to show previews of *newly* added files.

    // If we have a preview target, let's use it.
    // If not, we can insert previews into the drop zone or a designated area.
    if (!this.hasPreviewTarget) return

    this.previewTarget.innerHTML = ''

    Array.from(files).forEach(file => {
      if (!file.type.startsWith('image/')) return

      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        const div = document.createElement('div')
        div.className = "relative group"

        const img = document.createElement('img')
        img.src = reader.result
        img.className = "h-24 w-24 object-cover rounded-radius"

        div.appendChild(img)
        this.previewTarget.appendChild(div)
      }
    })

    this.previewTarget.classList.remove('hidden')
  }
}
